import React, { useMemo } from 'react';
import normalize, { JsonApiResponseSingle } from 'json-api-normalizer';
import { first, isEmpty } from 'lodash';
import build from 'redux-object';

import EntityPath from 'constants/entitiesPaths';
import { isEnabled, ServerSideFeature } from 'helpers/features';
import { useDefaultFaq } from 'hooks/useDefaultFaq';
import type { Faq } from 'types/entities/faq';
import ContentToggleWithSidebar from 'components/ContentToggleWithSidebar/ContentToggleWithSidebar';

interface Props {
  savedFaqData?: JsonApiResponseSingle;
}

const FaqComponent = ({ savedFaqData }: Props) => {
  const defaultFaq = useDefaultFaq();

  const faqToDisplay = useMemo(() => {
    if (!isEnabled(ServerSideFeature.CustomizableFaq)) {
      return defaultFaq;
    }

    return savedFaqData ? first(build<Faq>(normalize(savedFaqData), EntityPath.Faq)) : undefined;
  }, [defaultFaq, savedFaqData]);

  return faqToDisplay && !isEmpty(faqToDisplay.faqSections) ? (
    <ContentToggleWithSidebar faq={faqToDisplay} />
  ) : null;
};

export default FaqComponent;
